var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelegramIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13783_149884)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 0.5C8.81812 0.5 5.76375 1.76506 3.51562 4.01469C1.2652 6.26522 0.000643966 9.31734 0 12.5C0 15.6813 1.26562 18.7357 3.51562 20.9853C5.76375 23.2349 8.81812 24.5 12 24.5C15.1819 24.5 18.2362 23.2349 20.4844 20.9853C22.7344 18.7357 24 15.6813 24 12.5C24 9.31869 22.7344 6.26431 20.4844 4.01469C18.2362 1.76506 15.1819 0.5 12 0.5Z",
    fill: "url(#paint0_linear_13783_149884)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.43087 12.376C8.92962 10.852 11.2621 9.84723 12.4284 9.36173C15.7621 7.97554 16.454 7.73479 16.9059 7.72663C17.0052 7.72504 17.2265 7.7496 17.3709 7.86632C17.4909 7.96476 17.5246 8.09788 17.5415 8.19135C17.5565 8.28473 17.5771 8.49754 17.5602 8.66367C17.3802 10.5612 16.5984 15.1658 16.2009 17.2911C16.034 18.1904 15.7021 18.4919 15.3815 18.5213C14.684 18.5854 14.1552 18.0608 13.4802 17.6185C12.4246 16.926 11.8284 16.4952 10.8027 15.8196C9.61774 15.0389 10.3865 14.6097 11.0615 13.9084C11.2377 13.7249 14.309 10.932 14.3671 10.6787C14.3746 10.647 14.3821 10.5289 14.3109 10.4667C14.2415 10.4042 14.1384 10.4256 14.0634 10.4425C13.9565 10.4665 12.2709 11.5817 9.00087 13.788C8.52274 14.1169 8.08962 14.2772 7.69962 14.2688C7.27212 14.2596 6.44712 14.0265 5.83399 13.8274C5.08399 13.5831 4.48587 13.4539 4.53837 13.039C4.56462 12.823 4.86274 12.6019 5.43087 12.376Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13783_149884",
    x1: 1200,
    y1: 0.5,
    x2: 1200,
    y2: 2400.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2AABEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#229ED9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13783_149884"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegramIcon);
export default __webpack_public_path__ + "static/media/TelegramIcon.007c154dfbe91367500ddc72184e2d87.svg";
export { ForwardRef as ReactComponent };